/**
 * Site detection — figures out which of the two consumer sites the user is on:
 *   • "wealth"   → GetYourWealthReport.website  ($29 Retirement Readiness Score)
 *   • "annuity"  → YourAnnuityReview.com        (Free annuity review — original site)
 *
 * Detection rules (first match wins):
 *   1. URL path starts with /wealth     → wealth
 *   2. URL has ?site=wealth             → wealth (and sticks via sessionStorage)
 *   3. hostname is getyourwealthreport.com (or *.getyourwealthreport.*) → wealth
 *   4. otherwise → annuity
 */

const SITE_KEY = "arp_site_mode";

function readSearch() {
    if (typeof window === "undefined") return null;
    const p = new URLSearchParams(window.location.search).get("site");
    if (p === "wealth") {
        try { sessionStorage.setItem(SITE_KEY, "wealth"); } catch { /* ignore */ }
        return "wealth";
    }
    if (p === "annuity") {
        try { sessionStorage.removeItem(SITE_KEY); } catch { /* ignore */ }
        return "annuity";
    }
    return null;
}

function readHostname() {
    if (typeof window === "undefined") return null;
    const h = window.location.hostname.toLowerCase();
    if (h.includes("getyourwealthreport")) return "wealth";
    return null;
}

function readPath() {
    if (typeof window === "undefined") return null;
    const p = window.location.pathname || "";
    if (p === "/wealth" || p.startsWith("/wealth/")) return "wealth";
    return null;
}

export function getSite() {
    return (
        readPath() ||
        readSearch() ||
        readHostname() ||
        (typeof window !== "undefined" && sessionStorage.getItem(SITE_KEY) === "wealth" ? "wealth" : "annuity")
    );
}

export const isWealthSite = () => getSite() === "wealth";

/** Append ?site=wealth to a path when currently on the wealth site (preview helper). */
export function withSiteFlag(path) {
    if (typeof window === "undefined") return path;
    if (!isWealthSite()) return path;
    // If hostname already routes to wealth, no flag needed
    if (readHostname() === "wealth") return path;
    const sep = path.includes("?") ? "&" : "?";
    return `${path}${sep}site=wealth`;
}
